import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Label } from "reactstrap";
import { ErrorMessage, Field } from "formik";
import classnames from "classnames";

import { isValidPasswordChar } from "../helpers";
import PasswordCriteriaInfo from "./PasswordCriteriaInfo";

function PasswordField({
  fieldName = "password",
  id = "userPassword",
  label = "PASSWORD_LABEL",
  placeholder = "PASSWORD_PLACEHOLDER",
  setFieldValue,
  setBaseViewPassword = null,
  showPasswordCriteriaInfo = false,
  viewPasswordIndicator = true,
  isViewPassword = false,
  simple = false,
  basic = false,
  required = false,
}) {
  const { t } = useTranslation();

  const [viewPassword, setViewPassword] = useState(isViewPassword);

  useEffect(() => {
    setViewPassword(isViewPassword);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isViewPassword]);

  return (
    <React.Fragment>
      <div
        className={classnames(
          basic ? "basic-password-field" : "auth-form-group-custom",
          {
            "no-indicator": simple,
          }
        )}
      >
        {!simple && !basic && (
          <i className="ri-lock-2-line auti-custom-input-icon"></i>
        )}
        <Label htmlFor={id}>
          {required && "*"}
          {t(label)}&nbsp;
          {showPasswordCriteriaInfo && (
            <React.Fragment>
              <i className="ri-information-line" id="passwordCriteriaInfo"></i>
              <PasswordCriteriaInfo />
            </React.Fragment>
          )}
        </Label>

        <Field
          name={fieldName}
          type={viewPassword ? "text" : "password"}
          className="form-control"
          id={id}
          placeholder={t(placeholder)}
          onChange={(e) => {
            e.preventDefault();
            const { value } = e.target;
            isValidPasswordChar(value) && setFieldValue(fieldName, value);
          }}
        />

        {viewPasswordIndicator && (
          <i
            className={`ri-eye${
              viewPassword ? "" : "-off"
            }-line auti-custom-view-icon`}
            onClick={() => {
              setViewPassword(!viewPassword);
              setBaseViewPassword && setBaseViewPassword(!viewPassword);
            }}
          ></i>
        )}
      </div>

      <ErrorMessage name={fieldName} className="text-danger" component="div" />
    </React.Fragment>
  );
}

export default PasswordField;
